import React from 'react';
import { isUKSeller } from '../utils/sellerRegion';

// "Staying responsive pays more" alerts (thread seller-responsive-pays-more,
// parent seller-responsiveness-fb-messenger AC-2). The flow tells the seller
// that staying responsive pays more on Welcome (its own hero copy), the
// AutomatedLogin wait, PaymentDetails and Confirmation.
//
// The terms are Filip's, final (SELLER-OFFER-FINAL, 2026-09-28, relayed by
// b8191519): {s}20 at setup, a {s}5 ID badge bonus (worded as Step09 does:
// "Earn an extra {s}5", "when verified"), and for every
// re-verification "{s}10 now, increasing over time" -- soft on purpose, with no
// schedule. The currency follows the seller's region (isUKSeller). The other
// phrases already appear in the flow: "then ongoing income. Just stay
// responsive." / "Stay responsive when we message you, that's all it takes to
// keep earning." (Step01Welcome). Do not add an amount, a schedule or a term
// that is not in that list. The test in __tests__/responsive_pays_more.test.jsx
// allows only the 20, 5 and 10 amounts, and never the word "takeover"
// (mem-001594). partners-landing/src/App.tsx says the same re-verification line.
export function responsiveCopy(symbol) {
  const reverify = `${symbol}10 now, increasing over time`;
  return {
    automatedLogin: {
      title: 'Stay responsive, keep earning',
      body: `You get ${symbol}20 for setting up, and an extra ${symbol}5 when your ID badge is verified. Then you get paid every time you need to verify again: ${reverify}. Stay responsive when we message you, that’s all it takes to keep earning.`,
    },
    paymentDetails: {
      title: 'Then ongoing income. Just stay responsive.',
      body: `You get paid every time you need to verify again: ${reverify}. Stay responsive when we message you.`,
    },
    confirmation: {
      title: 'Keep earning: stay responsive',
      body: `You get paid every time you need to verify again: ${reverify}. Stay responsive when we message you, that’s all it takes to keep earning.`,
    },
  };
}

export const PLACEMENTS = Object.keys(responsiveCopy('$'));

export default function ResponsivePaysMore({ placement, sessionData }) {
  const symbol = isUKSeller(sessionData) ? '£' : '$';
  const copy = responsiveCopy(symbol)[placement];
  if (!copy) return null;
  return (
    <div className="responsive-alert" role="note" data-responsive-alert={placement}>
      <span className="responsive-alert__icon" aria-hidden="true">&#128276;</span>
      <div>
        <div className="responsive-alert__title">{copy.title}</div>
        <p className="responsive-alert__body">{copy.body}</p>
      </div>
    </div>
  );
}
